
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developer-tools/warehouse-tables",
      function () {
        return require("private-next-pages/developer-tools/warehouse-tables.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/developer-tools/warehouse-tables"])
      });
    }
  